module.exports = __webpack_public_path__ + "media/images/icons/icn_030-312724c2a340c3f5341ae04cd8257d05.svg";